import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "h-1.5 w-1.5 rounded-full bg-current opacity-70"
};
import { computed } from 'vue';
import { getBadgeMeta } from '../utils';
export default {
  __name: 'WealthStatusBadge',
  props: {
    type: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: ''
    },
    showDot: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const meta = computed(() => getBadgeMeta(props.type, props.value));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("span", {
        class: _normalizeClass(["status-badge inline-flex items-center gap-1", meta.value.class])
      }, [__props.showDot ? (_openBlock(), _createElementBlock("span", _hoisted_1)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(meta.value.label), 1)], 2);
    };
  }
};